// src/components/modules/Dialog/ReiniciarTrasladoDialog.js
import React, { useState } from "react";
import { Modal, Button, Typography, Input } from "antd";

const { Text } = Typography;
const { TextArea } = Input;

const ReiniciarTrasladoDialog = ({ open, onClose, onConfirm, trasladoId }) => {
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!motivo.trim()) {
      setError("Debe ingresar un motivo para reiniciar el traslado");
      return;
    }

    // Validar que el motivo no sea solo números
    if (/^\d+$/.test(motivo)) {
      setError("El motivo debe ser una descripción textual, no solo números");
      return;
    }

    console.log("Motivo capturado en diálogo:", motivo);
    onConfirm(trasladoId, motivo);

    setMotivo("");
    setError("");
  };

  const handleCancel = () => {
    setMotivo("");
    setError("");
    onClose();
  };

  return (
    <Modal
      title="Reiniciar Traslado"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleConfirm}
          disabled={!motivo.trim()}
        >
          Reiniciar
        </Button>,
      ]}
    >
      <div style={{ padding: "20px 0" }}>
        <Text strong>¿Está seguro de reiniciar este traslado?</Text>
        <ul style={{ marginTop: 15, paddingLeft: 20 }}>
          <li>El estado cambiará a "Programado"</li>
          <li>Se desasignará el móvil y conductor</li>
          <li>Se ajustarán las estadísticas de la autorización</li>
          <li>Se restarán traslados usados/cancelados/fallidos</li>
          <li>Se sumará un traslado en curso</li>
        </ul>

        <div style={{ marginTop: 20 }}>
          <Text strong>Motivo del reinicio:</Text>
          <TextArea
            rows={4}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Explique el motivo del reinicio..."
            style={{ marginTop: 8 }}
          />
          {error && (
            <Text type="danger" style={{ display: "block", marginTop: 8 }}>
              {error}
            </Text>
          )}
        </div>

        <Text type="warning" style={{ marginTop: 15, display: "block" }}>
          Esta acción no se puede deshacer
        </Text>
      </div>
    </Modal>
  );
};

export default ReiniciarTrasladoDialog;